import { createContext } from 'react';

export const UserContext = createContext({ _id: '', email: '', fetched: false });
export const BreweryContext = createContext({});
export const EntriesContext = createContext([]);
export const CategoriesContext = createContext([]);
